import { useState } from 'react';
import { MapPin, Clock, RefreshCw, X } from 'lucide-react';
import { formatDate } from '../../utils/date'; // Adjust import path

interface SavedLocationNoticeProps {
  savedAt: string; // ISO date string
  onUpdateLocation: () => void;
  isEditing?: boolean;
}

export const SavedLocationNotice: React.FC<SavedLocationNoticeProps> = ({
  savedAt,
  onUpdateLocation,
  isEditing = false,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible || !isEditing) return null;

  return (
    <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex items-start">
        <div className="flex-shrink-0 mt-0.5">
          <MapPin className="h-5 w-5 text-blue-600" />
        </div>
        
        <div className="ml-3 flex-1">
          <div className="flex justify-between items-start">
            <h4 className="text-sm font-medium text-blue-800">
              Location Previously Saved
            </h4>
            <button
              onClick={() => setIsVisible(false)}
              className="text-blue-400 hover:text-blue-600"
              aria-label="Hide notice"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          
          <div className="mt-2 flex items-center text-sm text-blue-700">
            <Clock className="h-4 w-4 mr-1.5 flex-shrink-0" />
            <span>Saved {formatDate(savedAt)}</span>
          </div>
          
          <p className="mt-2 text-sm text-blue-600">
            Your delivery location was captured at this address. 
            Update it only if you've moved or want more accuracy.
          </p>
          
          <div className="mt-3 flex gap-3">
            <button
              onClick={() => {
                onUpdateLocation();
                setIsVisible(false);
              }}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Update Location
            </button>
            <button
              onClick={() => setIsVisible(false)}
              className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Keep Saved Location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};